import React, { useState } from "react";

import Image from "../Image";
import PlayButton from "../PlayButton";

export interface VideoPlayerProps {
  title: string;
  src?: string;
  thumbnail?: string;
}

const VideoPlayer = ({ title, src, thumbnail }: VideoPlayerProps) => {
  const [isPlaying, setIsPlaying] = useState(src !== undefined);

  return (
    <div className="relative w-full h-full bg-black">
      {isPlaying ? (
        src?.includes("seaade-iadr-sea-2020-th.com") ? (
          <video
            className="w-full h-full"
            src={src}
            preload="auto"
            controls={true}
            autoPlay={true}
          ></video>
        ) : (
          <iframe
            title={title}
            src={src}
            width="100%"
            height="100%"
            scrolling="no"
            allow="autoplay"
            allowFullScreen
          ></iframe>
        )
      ) : (
        <>
          <Image src={thumbnail} />
          <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full">
            <PlayButton onClick={() => setIsPlaying(true)} />
          </div>
        </>
      )}
    </div>
  );
};

export default VideoPlayer;
